import { Component, OnInit,Renderer2,ViewChild,ElementRef,AfterViewInit} from '@angular/core';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-vs-parameter',
  templateUrl: './product-vs-parameter.component.html',
  styleUrls: ['./product-vs-parameter.component.scss']
})
export class ProductVsParameterComponent implements OnInit {
  addProductVsParameterForm!: FormGroup;
  productList:any[];
  p: number = 1;
  itemsPerPage : number = 10;
  productParameterList!:any[];
  ProductParameterName:any='';
  submitted:any=false;
  selectedproductId:any;
  parameterName:any="parameterName";
  parameterByProduct:any="";
  productParameterListByFilter:any[]=[];
  productParameterListSearchFilter:any[]=[];
  searchPerformed:boolean=false;

  productToSearch:any="";
  @ViewChild('dropdownsuggession') dropdownsuggession: ElementRef;
  constructor(private formBuilder: FormBuilder ,private fswService: FswService,private renderer: Renderer2, private toastr: ToastrService  ,private spinnerService: NgxSpinnerService) {
   

   }
  

  ngOnInit(): void {
    this.productParameterList=[];
    this.addProductVsParameterForm = this.formBuilder.group({
      productParameter: ['', [Validators.required]],
      product:['', [Validators.required]],
    
    

    })
    this.getProducts();

  }
//   ngAfterViewInit(): void {
//     this.renderer.listen('window', 'click',(e:Event)=>{
//       console.log(e);
//       console.log(e.target);
//       console.log(this.dropdownsuggession.nativeElement);
  
//   if( !this.dropdownsuggession.nativeElement.contains(e.target)){
      
//     if(this.productParameterListByFilter.length>0 )
//     {
//       this.productParameterListByFilter=[];
//     }
//   }
//   if(this.dropdownsuggession.nativeElement.contains(e.target))
//   {
    
//   }
// });
// this.renderer.listen(this.dropdownsuggession, 'click',(e:Event)=>{
//         console.log(e);

// })

   
// }
  getProducts()
  {
     this.fswService.getProducts().subscribe((resp)=>{

       this.productList=resp;
     


     } );
  }
  resetParameter()
  {
    this. productToSearch="";
    this.productParameterListSearchFilter= this.productParameterList;
  }
  searchProduct()
  {
    this.p=1;
    this.productParameterListSearchFilter= this.productParameterList.filter((proParam)=>
    {
           console.log(this.parameterByProduct);
           console.log(proParam.productName);
           if(proParam.parameterName.toLowerCase().indexOf(this.productToSearch.toLowerCase())!=-1)
           {
              console.log("true");
           }

        

       return (proParam.parameterName.toLowerCase().indexOf(this.productToSearch.toLowerCase())!=-1);
    });
    this.searchPerformed=true;

  }
 
  deleteParameter(productId,parameterId)
  {
    var delBtn = confirm("Do you want to delete the parameter?");
    if(delBtn)
    {
      let test_param_id=parameterId;
      console.log(productId);
      console.log(parameterId);
      this.fswService.deleteParameter(productId,test_param_id).subscribe((res)=>{

        this.fswService.getProductVsParameters(productId).subscribe((res)=>
        {
          console.log(res);
          this.productParameterList=res;
          this.productParameterListSearchFilter=res;
        });
      });
    }
  }
  onSelectParameter(e,parameterName)
  {
     console.log(e);
     e.stopPropagation()
     this.parameterByProduct=parameterName;
     this.productParameterListByFilter=[];
  }
  onChange(e)
  {
    this.p=1;
     if(e)
     {
     this.ProductParameterName='';
     this.productParameterList=[];
    
     let productId=e.productId;
     this.fswService.getProductVsParameters(productId).subscribe((res)=>
     {
       console.log(res);
       this.productParameterList=res;
       this.productParameterListSearchFilter=this.productParameterList;
     });
    }
    else{
      this.productParameterList=[];
    // this.ProductParameterName="";
     this.addProductVsParameterForm.controls['productParameter'].setValue('');
    }
  }
  searchParameter()
  {
        console.log(this.parameterByProduct);
      this.productParameterListByFilter= this.productParameterList.filter((proParam)=>
      {
             console.log(this.parameterByProduct);
             console.log(proParam.productName);
             if(proParam.parameterName.indexOf(this.productToSearch)!=-1)
             {
                console.log("true");
             }

           //if()

         return (proParam.parameterName.indexOf(this.parameterByProduct)!=-1);
      });
     
  }
  
  saveTestParameter()
  {
    this.submitted = true;
    let productParameter='';
     
 //    this.spinnerService.show();
    if (this.addProductVsParameterForm.invalid) {
      return;
    }
    let  productId= this.addProductVsParameterForm.get('product')?.value;
    console.log(this.addProductVsParameterForm.get('product')?.value);
    console.log( this.addProductVsParameterForm.get('productParameter')?.value);
    let type=typeof(this.addProductVsParameterForm.get('productParameter')?.value);
    if(type=='object')
    {
       productParameter=this.addProductVsParameterForm.get('productParameter')?.value.parameterName.replace(/ {2,}/g, ' ').trim();
      console.log(productParameter);
    }
    else
    {
       productParameter=this.addProductVsParameterForm.get('productParameter')?.value.replace(/ {2,}/g, ' ').trim();
      console.log(productParameter  );
    }
    console.log(productId);
    //console.log(productParameter);
    
    
    this.fswService.saveProductVsParameter({"productId": productId,"test_param":productParameter}).subscribe((resp) => {  
      console.log(resp);
      this.submitted = false;
      if(resp.status==205)
      {
        this.toastr.error('Product Parameter Already Exists');
      }
      else
      {
        this.toastr.success('Product Parameter Added Successfully');
      }
 //     this.spinnerService.hide();
     
   
    })
  }

}
